import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import color from 'color';
import { useIsRowLayoutMode } from '../hooks/useIsRowLayoutMode';
import { useAppSelector } from '../redux/store';
import { SELF_PANEL_BACKGROUND_COLOR } from '../styles/colors';
import { DomAvatarDisplay } from './domAvatarDisplay';
const BORDER_COLOR = color(SELF_PANEL_BACKGROUND_COLOR).darken(0.3).string();
const CONTAINER_BASE_CSS = css `
  position: absolute;
  background-color: ${SELF_PANEL_BACKGROUND_COLOR};
  padding: 15px 10px 10px 10px;
  border-bottom: 4px solid ${BORDER_COLOR};
`;
const ROW_MODE_CONTAINER_CSS = css(CONTAINER_BASE_CSS, css `
    left: -192px;
    top: 0;
    border-radius: 0 0 0 10px;
    border-left: 4px solid ${BORDER_COLOR};
  `);
const COLUMN_MODE_CONTAINER_CSS = css(CONTAINER_BASE_CSS, css `
    border-radius: 0 0 10px 0;
    border-right: 4px solid ${BORDER_COLOR};
  `);
export const DomAvatarFloatingDisplayContainer = () => {
    const isAvatarEditorOpen = useAppSelector((state) => state.selfAvatar.isAvatarEditorOpen);
    const pendingPlayerAvatar = useAppSelector((state) => state.selfAvatar.avatar?.pendingAvatar);
    const isRowLayoutMode = useIsRowLayoutMode();
    if (!isAvatarEditorOpen) {
        return null;
    }
    if (!pendingPlayerAvatar) {
        return null;
    }
    return (_jsx("div", { css: isRowLayoutMode ? ROW_MODE_CONTAINER_CSS : COLUMN_MODE_CONTAINER_CSS, children: _jsx(DomAvatarDisplay, { playerAvatar: pendingPlayerAvatar, backgroundColor: SELF_PANEL_BACKGROUND_COLOR }) }));
};
